import React, { useRef, useState } from 'react';
import { Box } from '@mui/material';

interface ConferirAoMexerProps {
  /** A linha acabou de entrar com o valor padrão. */
  sugerido: boolean;
  /** O selo "confira" que acompanha o valor sugerido. */
  selo: React.ReactNode;
  children: React.ReactNode;
}

/**
 * O selo "confira" fica só enquanto o valor é sugestão: trocar o valor tira o selo, e abrir o
 * campo e escolher de novo o mesmo valor também — a pessoa conferiu. Passar pelo campo com Tab
 * não conta.
 */
export function ConferirAoMexer({ sugerido, selo, children }: ConferirAoMexerProps) {
  const [conferido, setConferido] = useState(false);
  const mexeu = useRef(false);
  const marcarQueMexeu = () => {
    mexeu.current = true;
  };
  return (
    <Box
      onChange={() => setConferido(true)}
      onMouseDown={marcarQueMexeu}
      onKeyDown={(evento: React.KeyboardEvent) => {
        if (evento.key !== 'Tab') marcarQueMexeu();
      }}
      onBlur={() => {
        if (mexeu.current) setConferido(true);
      }}
    >
      {children}
      {sugerido && !conferido && selo}
    </Box>
  );
}
